export const getListGifts = (state: any): any => state.gifts.giftsList;
export const findGiftByID = (state: any, id: string): any => {
    const listGifts = getListGifts(state);
    return listGifts.find((gift: any) => gift._id === id);
};
export const getPagination = (state: any): any => state.gifts.pagination;
export const getSearch = (state: any): any => state.gifts.search;
